import React from 'react';
import { HomeIcon } from 'lucide-react';
const stats = [{
  value: '+7',
  label: 'Tomos'
}, {
  value: '+100',
  label: 'Actividades'
}, {
  value: '+5',
  label: 'Bonos'
}, {
  value: '90',
  label: 'Días de calendario'
}];
export function SystemOverview() {
  return <section className="bg-teal-900 py-10 text-cream-50 sm:py-20" aria-labelledby="sistema" data-id="element-248" data-mp="1moi64603gdrt">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-249" data-mp="1hpx5w6kudu3d">
        <div className="text-center" data-id="element-250" data-mp="tz1kbr6zbv4k">
          <h2 id="sistema" className="font-display text-2xl font-800 uppercase leading-tight sm:text-4xl" data-id="element-251" data-mp="u02w5xvtklnc">
            Un sistema completo para{' '}
            <span className="text-gold-400" data-id="element-252" data-mp="13xhbtv9x56el">acompañar mejor</span>
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-[0.8rem] text-cream-100/80 sm:mt-4 sm:text-base" data-id="element-253" data-mp="ywbhxu4ivd3h">
            Actividades listas para usar y todo organizado en un solo lugar.
          </p>
        </div>

        <dl className="mt-6 grid grid-cols-4 gap-px overflow-hidden rounded-2xl bg-cream-50/12 sm:mt-12" data-id="element-254" data-mp="2abq9ujhvjerq">
          {stats.map(stat => <div key={stat.label} className="bg-teal-900 px-1.5 py-4 text-center sm:px-5 sm:py-7" data-id="element-255" data-mp="285gxrfkh8lfq">
              <dt className="sr-only" data-id="element-256" data-mp="2d5len6pari6h">{stat.label}</dt>
              <dd data-id="element-257" data-mp="2i3mxprmq3hhy">
                <span className="block font-display text-xl font-900 text-gold-400 sm:text-5xl" data-id="element-258" data-mp="2i46hzezuihz5">
                  {stat.value}
                </span>
                <span className="mt-1 block font-display text-[0.6rem] font-700 uppercase leading-tight tracking-[0.1em] text-cream-100/70 sm:mt-2 sm:text-xs sm:tracking-[0.16em]" data-id="element-259" data-mp="1khpka8n7a2cv">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <p className="mt-5 flex items-start justify-center gap-2 text-center text-[0.8rem] text-cream-100/70 sm:mt-8 sm:items-center sm:text-sm" data-id="element-260" data-mp="1z63p2p46g0w2">
          <HomeIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-400 sm:mt-0" aria-hidden="true" data-id="element-261" data-mp="16nybj2hammi7" />
          Funciona desde hoy en tu casa, patio, habitación o durante una visita familiar.
        </p>
      </div>
    </section>;
}